import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  success: false,
  error: false,
  results: []
};

const ResultSlice = createSlice({
  name: "Result",
  initialState,
  reducers: {
    getResultStart: (state, action) => {
      state.loading = true;
      state.error = false;
    },
    getResultSuccess: (state, action) => {
      state.loading = false;
      state.error = false;
      state.results = action?.payload?.findResult;
      state.page = action?.payload?.currentPage;
      state.totalpage = action?.payload?.totalPage;
    },
    getResultFailure: (state, action) => {
      state.loading = false;
      state.error = true;
    },
    resetResults: (state) => {
      state.results = [];
    }
  }
});

export const {
  getResultStart,
  getResultSuccess,
  getResultFailure,
  resetResults
} = ResultSlice.actions;

export default ResultSlice.reducer;
